export const actions = {
  PROVEEDORES_LOAD_REQUESTED: 'PROVEEDORES_LOAD_REQUESTED',
  PROVEEDORES_LOAD_SUCCEEDED: 'PROVEEDORES_LOAD_SUCCEEDED',
  PROVEEDORES_LOAD_FILED: 'PROVEEDORES_LOAD_FILED',

  PROVEEDOR_BYID_LOAD_REQUESTED: 'PROVEEDOR_BYID_LOAD_REQUESTED',
  PROVEEDOR_BYID_LOAD_SUCCEEDED: 'PROVEEDOR_BYID_LOAD_SUCCEEDED',
  PROVEEDOR_BYID_LOAD_FILED: 'PROVEEDOR_BYID_LOAD_FILED',

  PROVEEDOR_BYID_LOAD_INSERT_REQUESTED: 'PROVEEDOR_BYID_LOAD_INSERT_REQUESTED',

  PROVEEDOR_UPDATE_REQUESTED: 'PROVEEDOR_UPDATE_REQUESTED',
  PROVEEDOR_UPDATE_SUCCEEDED: 'PROVEEDOR_UPDATE_SUCCEEDED',
  PROVEEDOR_UPDATE_FILED: 'PROVEEDOR_UPDATE_FILED',

  PROVEEDOR_INSERT_REQUESTED: 'PROVEEDOR_INSERT_REQUESTED',
  PROVEEDOR_INSERT_SUCCEEDED: 'PROVEEDOR_INSERT_SUCCEEDED',
  PROVEEDOR_INSERT_FILED: 'PROVEEDOR_INSERT_FILED',

  PROVEEDOR_DELETE_REQUESTED: 'PROVEEDOR_DELETE_REQUESTED',
  PROVEEDOR_DELETE_SUCCEEDED: 'PROVEEDOR_DELETE_SUCCEEDED',
  PROVEEDOR_DELETE_FILED: 'PROVEEDOR_DELETE_FILED',
}

export const getProveedoresAction = dispatch => {
  dispatch({
    type: actions.PROVEEDORES_LOAD_REQUESTED,
  })
}

export const getProveedorCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.PROVEEDOR_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.PROVEEDOR_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const onSubmitInsertProveedorFormAction = (dispatch, formProveedor) => {
  dispatch({
    type: actions.PROVEEDOR_INSERT_REQUESTED,
    payload: formProveedor,
  })
}

export const onSubmitUpdateProveedorFormAction = (dispatch, formProveedor) => {
  dispatch({
    type: actions.PROVEEDOR_UPDATE_REQUESTED,
    payload: formProveedor,
  })
}

export const deleteProveedorAction = (dispatch, id) => {
  dispatch({
    type: actions.PROVEEDOR_DELETE_REQUESTED,
    payload: id,
  })
}
